// extracted by mini-css-extract-plugin
module.exports = {"dayPicker":"DatePicker_dayPicker__XL5Gl"};